/**
 * The roles a Team Owner or Team Admin may give when adding a user (AddUserPage).
 *
 * ⚠️ Ids are `public.roles.id`, read live. Team Owners hold no reserved permission, so nothing
 * here may carry one: create-admin-user refuses it since RBAC-1.5. See the test for why.
 */
export const TEAM_ASSIGNABLE_ROLES: readonly { id: string; name: string }[] = [
  { id: '1', name: 'Sales Rep' },
  // F-142: was '37', which is Finance (carries manage_settings). Sales Manager is 2.
  { id: '2', name: 'Sales Manager' },
  { id: '44', name: 'Team Admin' },
];
